<template>
    <div v-wechat-title="title">
        <el-row type="flex" align="middle">
            <el-col :md="9" :lg="6" :xl="5">
                <item-input type="daterange" v-model="rdate" :noPadding="true"></item-input>
            </el-col>
            <el-col :md="5" :lg="4" :xl="3"><item-input type="select" v-model="dic_operating_ward_id" :options="operation_ward_auth" placeholder="请选择区域"></item-input></el-col>
            <el-col :md="5" :lg="3" :xl="3">
                <item-input type="select" v-model="dic_operating_room_id" :options="operationRooms" placeholder="手术间" style="display: inline-block" :clearable="true"></item-input
            ></el-col>
            <el-col :md="4" :lg="2" :xl="2">
                <item-input type="select" v-model="surgery_type" :options="sys_enums && sys_enums.Enum_SurgeryType" placeholder="手术类型" style="display: inline-block" :clearable="true"></item-input
            ></el-col>
            <el-col :md="4" :lg="2" :xl="2">
                <item-input type="select" v-model="isSealed" :options="sys_enums && sys_enums.Enum_SealState" placeholder="病案状态" style="display: inline-block" :clearable="true"></item-input
            ></el-col>
            <el-col :md="5" :lg="3" :xl="3">
                <item-input type="multiselect" v-model="surgery_status" :options="sys_enums && sys_enums.SurgeryStatus" :clearable="true" placeholder="手术状态"></item-input>
            </el-col>
            <el-col :md="1" :lg="3" :xl="3"><item-input type="checkbox" v-model="is_own" style="display: inline-block; width: 50px">我的患者</item-input> </el-col>
            <el-col :md="5" :lg="3" :xl="3"> <item-input type="search" placeholder="关键字搜索" v-model="searchValue" class="width-p100"></item-input></el-col>
            <el-col :md="5" :lg="4" :xl="3"> <el-button type="primary" size="mini" @click="query()">查询</el-button> <el-link type="info" size="mini" plain @click="reset">重置</el-link></el-col>
            <el-button type="primary" size="mini" @click="seal" v-if="this.permissions && this.permissions.findIndex(item => item.permission === `medical:Seals`) != -1">病案封存</el-button>
            <el-button type="primary" size="mini" style="margin-right: 10px" @click="unSeal" v-if="this.permissions && this.permissions.findIndex(item => item.permission === `medical:Seals`) != -1"
                >取消封存</el-button
            >
            <el-popover placement="bottom" :open-delay="600">
                <el-button size="mini" plain slot="reference">
                    <font-awesome-icon :icon="['fas', 'cog']"></font-awesome-icon>
                    <span class="hidden-md-and-down">&nbsp;列配置</span>
                </el-button>
                <el-scrollbar wrap-class="scrollbar-wrapper-y" style="height: 250px; width: max-content">
                    <div class="config-column">
                        <item-input type="checkboxgroup" :options="configColumns" v-model="user_config_columns"></item-input>
                    </div>
                </el-scrollbar>

                <el-divider></el-divider>
                <div style="text-align: right">
                    <el-link type="primary" size="mini" class="margin-right10" @click="SaveUserColumns">保存</el-link>
                </div>
            </el-popover>
        </el-row>
        <list-view
            ref="surgery-list"
            :datalist="alldata"
            :columns="userListColumn"
            :buttons="buttons"
            :selection="true"
            :addButton="{ enabled: false }"
            :deleteButton="{ enabled: false }"
            :tableHeight="screenHeight - 150 - 34"
            :updateButton="{ enabled: false }"
            @gotoSurgeryInfo="gotoSurgeryInfo"
            :filterSpan="[16, 5]"
            :fuzzySearch="false"
            :columnConfig="false"
            @extrabutton-click="ExtraButtonClick"
        >
            <template slot="patient_info" slot-scope="{ row }">
                <el-row :title="row.is_history ? `历史导入数据` : null">
                    <el-col :span="1" class="height-p100">
                        <div
                            class="surgery-status-tag"
                            style="height: 80px"
                            :class="row.enum_surgery_status == 30 ? 'bg-danger' : row.enum_surgery_status == 20 || row.enum_surgery_status == 10 ? 'bg-primary' : 'bg-info'"
                        >
                            &nbsp;<br />&nbsp;<br />&nbsp;
                        </div>
                    </el-col>
                    <el-col :span="22" class="padding5 padding-none-v align-left">
                        <div class="ellipsis" :title="`${row.patient_name}(${row.sex || '--'}/${row.age || '--'}/${row.visit_no}/${row.bed_no || '--'}床)`">
                            <b>
                                <el-tag :type="row.enum_surgery_type == 1 ? 'danger' : 'primary'" size="mini" v-if="row.enum_surgery_type">{{ row.surgery_type }}</el-tag>
                                <span class="circle fg-red borderd" v-if="row.is_reoperation">再</span>
                                {{ `${row.patient_name}(${row.sex || '--'}/${row.age || '--'}/${row.visit_no}/${row.bed_no || '--'}床)` }}
                            </b>
                        </div>
                        <div>
                            <b class="ellipsis">{{ row.surgeries }}</b>
                        </div>
                        <div>
                            <b class="ellipsis">{{ row.diseases }}</b>
                        </div>
                    </el-col>
                    <el-col v-show="row.is_history" :span="1" class="height-p100">
                        <p style="font-size: x-large; font-weight: bold; color: red">i</p>
                    </el-col>
                </el-row>
            </template>
            <template slot="archive_all_quantity" slot-scope="{ row }">
                <div v-if="row.documentAllCount && row.documentAllCount > 0">{{row.archive_quantity}}/{{row.documentAllCount}}</div>
            </template>
            <template slot="surgeon_info" slot-scope="{ row }">
                <div style="width: 90px; white-space: normal">
                    <span>{{ row.surgeon && `(主)${row.surgeon}` }}</span>
                </div>
                <div class="fg-info">
                    <span>{{ row.surgeon_assistants }}</span>
                </div>
            </template>
            <template slot="anes_doctor_info" slot-scope="{ row }">
                <div style="width: 90px; white-space: normal">
                    <span>{{ row.anes_doctor && `(主)${row.anes_doctor}` }}</span>
                </div>
                <div class="fg-info">
                    <span>{{ row.anes_assistants }}</span>
                </div>
            </template>
        </list-view>
        <el-pagination
            class="align-left"
            background
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="pageChange"
            @current-change="pageChange"
            :page-sizes="[10, 20, 50, 100, 200]"
            :current-page.sync="currentPage"
            :page-size.sync="pageSize"
            :total="total"
        >
        </el-pagination>
        <el-drawer key="drawer1" :visible.sync="drawerVisible" :with-header="false" direction="rtl">
            <el-scrollbar wrap-class="scrollbar-wrapper-y" style="height: 100%; background: white">
                <div class="align-left" style="padding: 15px 0 0px 15px; color: var(--primary-color, #009688); font-weight: bold">文书完成率：{{ documentRate }}%</div>
                <div class="align-left font-size12" style="padding: 15px 0 0px 15px; font-weight: bold">
                    <span class="el-icon-location fg-primary font-size14" v-if="thisrow"></span>
                    申请时间：{{ (thisrow && $moment(thisrow.apply_time).format('YYYY/MM/DD HH:mm')) || '--' }}
                    <span class="circle fg-red borderd" v-if="thisrow && thisrow.is_reoperation">再</span>
                    <br />
                    <span class="fg-info">【{{ thisrow && thisrow.surgery_status }}】：{{ (thisrow && $moment(thisrow.status_time).format('YYYY/MM/DD HH:mm')) || '--' }}</span>
                </div>
                <template v-for="(item, index) in documentList">
                    <div v-if="item.hasChildren && item.children.length != 0" :key="index" class="padding10">
                        <div class="title align-left padding5">
                            <el-link @click="gotoDocument(item)"
                                ><span class="el-icon-document"></span><b>{{ item.label }}</b></el-link
                            >&nbsp;&nbsp;({{ item.children.length }})
                        </div>
                        <div class="padding20 padding-none-v">
                            <div v-for="c in item.children" :key="c.index" class="align-left cursor-pointer" @click="loadInstance(c)">
                                {{ c.label }} &nbsp;&nbsp;<span class="fg-info">{{ c.createby }}{{ c.lastupdatedt }}</span> &nbsp;&nbsp;&nbsp;&nbsp;
                                <span class="cus-button is-circle" @click.stop="archive(c)">
                                    <font-awesome-icon :icon="['fas', 'lock']" title="点击取消归档" class="fg-warning" v-if="c.archiveddt"></font-awesome-icon>
                                    <font-awesome-icon :icon="['fas', 'lock-open']" title="点击归档" class="fg-warning" v-else></font-awesome-icon>
                                </span>
                                <span class="cus-button is-circle" @click.stop="printDocment(c)">
                                    <span class="el-icon-printer"></span>
                                </span>
                            </div>
                        </div>
                    </div>
                </template>
            </el-scrollbar>
        </el-drawer>
        <cus-dialog class="document-medicalrecord" :title="document.title" :visible.sync="document.dialogFormVisible" width="60%" :footerVisible="false">
            <DocFrame v-if="document.docno > 0" ref="doc" :docno="document.docno" :docbizid="document.docbizid" :surgeryId="surgeryId"></DocFrame>
            <div v-else style="min-height: 600px" v-loading="loading">
                <pdf v-for="i in numPages" :key="i" :src="src" :page="i"></pdf>
            </div>
        </cus-dialog>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import Sortable from 'sortablejs'
import pdf from '@/common/vue-pdf-4.1.0'
import axios from 'axios'
import Qs from 'qs'
import printJs from 'print-js'
export default {
    name: `Medicalrecord`,
    components: { pdf },
    props: {},
    data() {
        return {
            title: `病案浏览`,
            buttons: [
                {
                    label: `归档详情`,
                    type: `primary`,
                    emit: `loadDocArchiveView`,
                    permission: `default`
                },
                {
                    label: `患者数据`,
                    type: `primary`,
                    emit: `gotoSurgeryInfo`,
                    permission: `default`
                }
            ],
            url: {
                area: `medicalrecord`,
                baseURL: `/api/Preoperative/Apply`,
                get: paras => {
                    return this.ReloadListData()
                }
            },
            rdate: [
                this.$moment()
                    .add(-this.$root.MedicalRecordDays, `days`)
                    .format(`YYYY/MM/DD`),
                this.$moment()
                    .format(`YYYY/MM/DD`)
            ],
            o_dic_operating_ward_id: undefined,
            dic_operating_room_id: null,
            surgery_type: null,
            isSealed: null,
            surgery_status: [40, 60],
            currentPage: 1,
            pageSize: 50,
            total: 0,
            is_own: false,
            searchValue: ``,
            configColumns: [],
            user_config_columns: [],
            user_config_columns2: [],
            issetoperatingward: false,
            documentList: [],
            surgeryId: undefined,
            drawerVisible: false,
            drawerVisible2: false,
            document: {
                title: ``,
                dialogFormVisible: false,
                docno: ``,
                docbizid: ``
            },
            src: undefined,
            numPages: 0,
            loading: false,
            checkedRow: [],
            is_sealed: 0,
            ward_id: undefined,
            permissions: [],
            thisrow: {},
            alldata: [],
            DicDocManagementList: null,
            DocumentConfig: null
        }
    },
    created() {
        this.loadPermissions()
        this.query()
    },
    mounted() {
        this.$store.dispatch(`ADD_SECTION_AUTH`)
        // 加载配置列
        this.loadConfigColumns()
        this.configColumnDrop()
    },
    computed: {
        ...mapGetters([`screenHeight`, `screenWidth`, `ward_auth`, `operation_ward_auth`, `business`, `currentUser`, `sys_enums`, `screenWidth`, `screenHeight`, `active_ward`,
            `otherSettingColumn`,
            `extendColumnList`]),
        documentRate() {
            if (this.documentList) {
                let sum = 0
                let calc = 0
                for (let item of this.documentList) {
                    if (item.hasChildren && item.children.length != 0) {
                        sum += item.children.length
                        for (let c of item.children) {
                            if (c.archiveddt) {
                                calc++
                            }
                        }
                    }
                }
                if (sum == 0) return `--`
                return parseFloat((calc * 100.0) / (sum * 1.0)).toFixed(2)
            }
        },
        dic_operating_ward_id: {
            get: function() {
                if (!this.issetoperatingward && this.active_ward && _.startsWith(this.active_ward.value, `ow_`)) {
                    this.o_dic_operating_ward_id = this.active_ward.origion
                }
                return this.o_dic_operating_ward_id
            },
            set: function(v) {
                this.o_dic_operating_ward_id = v
                this.issetoperatingward = true
            }
        },
        operationRooms: {
            get() {
                let r = this.operation_ward_auth && this.operation_ward_auth.find(i => i.value == this.dic_operating_ward_id)
                return r && r.operation_room.length > 0 ? _.orderBy(r.operation_room, `display_order`) : []
            },
            set() { }
        },
        columnList() {
            let list = [
                {
                    type: `string`,
                    prop: `id`,
                    label: `编号`,
                    isKey: true
                },
                {
                    type: `select`,
                    prop: `is_sealed`,
                    label: `病案状态`,
                    width: `70`
                },
                {
                    type: `select`,
                    prop: `is_sealed2`,
                    label: `病案状态`,
                    width: `70`,
                    isListable: true,
                    options: this.sys_enums.Enum_SealState || []
                },
                {
                    type: `select`,
                    prop: `sealing_status`,
                    label: `审核状态`,
                    width: `70`,
                    isListable: true,
                    options: [
                        { value: 0, label: `未处理` },
                        { value: 1, label: `审核中` },
                        { value: 2, label: `审核成功` },
                        { value: 3, label: `审核失败` }
                    ] // ,
                    // isKey: true
                },
                {
                    type: `custom`,
                    prop: `patient_info`,
                    label: `患者信息卡`,
                    width: `360`,
                    isListable: true
                },
                {
                    type: `custom`,
                    prop: `archive_all_quantity`,
                    label: `归档数量`,
                    width: `70`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `patient_name`,
                    label: `患者姓名`,
                    width: `120`,
                    queryable: true
                },
                {
                    type: `string`,
                    prop: `visit_no`,
                    label: this.T(`medicalrecord.visit_no`),
                    width: `100`,
                    queryable: true
                }, {
                    type: `string`,
                    prop: `his_id`,
                    label: this.T(`his_id`),
                    width: `120`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `sex`,
                    label: `性别`,
                    width: `60`,
                    queryable: true
                },
                {
                    type: `string`,
                    prop: `age`,
                    label: `年龄`,
                    width: `60`,
                    queryable: true
                },
                {
                    type: `string`,
                    prop: `dic_section`,
                    label: `科室`,
                    width: `100`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `diseases`,
                    label: `诊断`,
                    width: `200`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `surgeries`,
                    label: `手术`,
                    width: `200`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `anaes_methods`,
                    label: `麻醉方式`,
                    width: `100`,
                    isListable: true
                },

                {
                    //   type: "string",
                    //   prop: "blood",
                    //   label: "血型",
                    //   width:"80",
                    //   isListable: true
                    // }, {
                    //   type: "string",
                    //   prop: "height",
                    //   label: "身高",
                    //   width:"60",
                    //   isListable: true
                    // }, {
                    //   type: "string",
                    //   prop: "weight",
                    //   label: "体重",
                    //   width:"60",
                    //   isListable: true
                    // }, {
                    type: `string`,
                    prop: `dic_operating_room`,
                    label: `手术间`,
                    width: `80`,
                    isListable: true
                    // sortable: false
                },
                {
                    type: `select`,
                    prop: `enum_surgery_status`,
                    label: `手术状态`,
                    width: `80`,
                    isListable: true,
                    options: this.sys_enums.SurgeryStatus || []
                },
                {
                    type: `select`,
                    prop: `enum_surgery_type`,
                    label: `手术类型`,
                    width: `80`,
                    queryable: true,
                    options: this.sys_enums.Enum_SurgeryType || []
                },
                {
                    type: `datetime`,
                    prop: `plan_time`,
                    label: `计划手术时间`,
                    width: `120`,
                    isListable: true
                },
                {
                    type: `datetime`,
                    prop: `in_room_time`,
                    label: `实际手术时间`,
                    width: `120`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `surgeries`,
                    label: `手术名称`,
                    queryable: true
                },
                {
                    type: `string`,
                    prop: `diseases`,
                    label: `术前诊断`,
                    queryable: true
                },
                {
                    type: `custom`,
                    prop: `surgeon_info`,
                    label: this.T(`medical_record.plan_surgeon`),
                    width: `90`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `surgeon`,
                    label: this.T(`medical_record.plan_surgeon`),
                    queryable: true
                },
                {
                    type: `string`,
                    prop: `surgeon_assistants`,
                    label: this.T(`medical_record.plan_surgeon_assistants`),
                    queryable: true
                },
                {
                    type: `custom`,
                    prop: `anes_doctor_info`,
                    label: this.T(`medical_record.plan_anes_doctor`),
                    width: `90`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `anes_doctor`,
                    label: this.T(`medical_record.plan_anes_doctor`),
                    queryable: true
                },
                {
                    type: `string`,
                    prop: `anes_assistants`,
                    label: this.T(`medical_record.plan_anes_assistants`),
                    queryable: true
                },
                {
                    type: `string`,
                    prop: `equipment_nurse`,
                    label: this.T(`medical_record.plan_equipment_nurse`),
                    width: `80`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `circuit_nurse`,
                    label: this.T(`medical_record.plan_circuit_nurse`),
                    width: `80`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `remark`,
                    label: `备注`,
                    isListable: true
                }
            ]

            // 显示动态扩展列
            list = this.$surgeryInfoExtraParamUtil.SetExtraColumnList(this.extendColumnList, list)
            return list
        },
        userListColumn() {
            let that = this
            if (this.configColumns.length == 0) {
                return this.columnList
            } else if (this.user_config_columns.length == 0) {
                // added by xiaorui,默认如果用户没有配置任何列 则 1.列配置勾选上当前页面所有列 2.展示当前列表上所有列
                that.user_config_columns = that.configColumns.map(c => c.value)
                return this.columnList
            }
            let allcolumn = _.filter(this.columnList, c => {
                return _.includes(this.user_config_columns, c.prop) || c.isExpand || c.isKey || (c.isDisplayOrder && c.isListable)
            })
            let r = _.orderBy(allcolumn, function(ac) {
                let i = _.findIndex(that.configColumns, { value: ac.prop })
                return i
            })
            return r
        },
        filterDocumentList() {
            let nd = _.filter(this.documentList, d => d.children && d.children.length > 0)
            let r = _.reduce(
                _.groupBy(nd, `surgeryId`),
                function(result, v, key) {
                    result.push({
                        surgeryId: key,
                        surgery: v[0].surgery,
                        children: v
                    })
                    return result
                },
                []
            )
            return _.orderBy(r, `surgery.apply_time`)
        }
    },
    methods: {
        ExtraButtonClick(target) {
            if (this[target.emit]) {
                this[target.emit](target)
            } else {
                this.$emit(target.emit, target)
            }
        },
        loadPermissions() {
            let req = this.myaxios.get(`/api/AcisSystem/Authorization/GetPermissions`) // 获取当前用户的权限
            req.then(data => {
                this.permissions = data
            }).catch(e => {
            })
        },
        pageChange() {
            this.ReloadListData()
        },
        query() {
            this.currentPage = 1
            this.ReloadListData()
        },
        reset() {
            this.dic_operating_room_id = null
            this.surgery_type = null
            this.isSealed = null
            this.surgery_status = []
            this.searchValue = ``
            this.currentPage = 1
            this.ReloadListData()
        },
        ReloadListData() {
            // 更改日期触发更新列表
            let that = this
            let req = that.myaxios.postpagination(`/api/Operation/Home/SurgeryQueryPage?pageIndex=${this.currentPage}&pageSize=${this.pageSize}`, {
                begin: that.rdate[0],
                end: this.$moment(this.rdate[1]).add(1, `days`).format(`YYYY/MM/DD`),
                dic_operating_ward_id: that.dic_operating_ward_id,
                dic_operating_room_id: that.dic_operating_room_id || 0,
                surgery_type: that.surgery_type || 0,
                is_sealed: that.isSealed,
                keyword: this.searchValue,
                is_own: this.is_own,
                surgery_status: that.surgery_status
            })
            req.then(res => {
                this.total = res.count
                var data = res.data
                // let sk = (this.searchValue) || ``
                // if (sk.length > 0) {
                //     data = _.filter(data, x => this.filterCondition(x))
                // }
                // if (this.is_own) {
                //     data = _.filter(data, x => x.is_own_data_auth_filter == true)
                // }
                let r = data && data.map(d => {
                    d.is_sealed = !!d.is_sealed
                    d.is_sealed2 = d.is_sealed == true ? 1 : 0
                    this.$surgeryInfoExtraParamUtil.SetSurgeryInfoObj(this.extendColumnList, d, d)
                    return d
                })
                console.log(r)
                this.loadDicDocManagementList(r)
                // resolve()
            })
        },
        // 关键字查询
        filterCondition(d) {
            if (this.searchValue) {
                return (d.patient_name && d.patient_name.indexOf(this.searchValue) > -1) ||
                (d.visit_no && d.visit_no.indexOf(this.searchValue) > -1) ||
                (d.sex && d.sex.indexOf(this.searchValue) > -1) ||
                    (d.age && d.age.indexOf(this.searchValue) > -1) ||
                    (d.bed_no && d.bed_no.indexOf(this.searchValue) > -1) ||
                (d.dic_section && d.dic_section.indexOf(this.searchValue) > -1) ||
                (d.surgeries && d.surgeries.indexOf(this.searchValue) > -1) ||
                (d.diseases && d.diseases.indexOf(this.searchValue) > -1) ||
                (d.surgeon && d.surgeon.indexOf(this.searchValue) > -1) ||
                (d.surgeon_assistants && d.surgeon_assistants.indexOf(this.searchValue) > -1) ||
                (d.anes_doctor && d.anes_doctor.indexOf(this.searchValue) > -1) ||
                (d.anes_assistants && d.anes_assistants.indexOf(this.searchValue) > -1) ||
                (d.equipment_nurse && d.equipment_nurse.indexOf(this.searchValue) > -1) ||
                (d.circuit_nurse && d.circuit_nurse.indexOf(this.searchValue) > -1)
            }
            return true
        },
        gotoSurgeryInfo({ row, index }) {
            // let r = _.find(this.business, { business_level: `M003`, location: `basic_info` })
            // this.$router.push(`${(r && r.url) || `/`}?surgery_id=${row.id}`)
            let r = _.find(this.business, { business_level: `M003`, location: `basic_info` })
            let url = (r && r.url) || `/`
            // 本系统页面链接，直接调用患者管理路由加载界面
            url += url.indexOf(`?`) > -1 ? `&` : `?`
            url = `${url}surgery_id=${row.id}&isOnlyShowMain=true&workbar=${r.workbar}&record_type=1`
            let routeUrl = this.$router.resolve({
                path: url
            })
            var w = this.screenWidth - 10
            var h = this.screenHeight - 10
            if (typeof winformMsg != `undefined`) {
                w = w + 500
                h = h + 400
            }
            window.open(routeUrl.href, ``, `width=${w},height=${h},top=10,left=10`)
        },
        archive(c) {
            if (this.is_sealed) {
                this.$message.warning(`病案已封存,不允许归档操作`)
                return false
            }

            if (c.docno > 0) { // 文书
                // 归档
                if (!c.archiveddt) {
                    if (this.permissions && this.permissions.findIndex(item => item.permission === `Document:Archive`) != -1) {
                        let req = axios.get(`${this.$root.DOCSERVICE_BASE}/Wth/ArchiveInstance`, {
                            headers: { 'content-type': `application/x-www-form-urlencoded` },
                            params: { docbizid: c.docbizid, operator: this.currentUser.dic_worker_name }
                        })
                        req.then(data => {
                        // 保存无纸化记录,文书3.2.6才会支持Content数据返回[jira:ICIS-13291]
                            if (this.$root.PaperlessEnabled == 1 && data.Content && data.Content.Sysid > 0 && data.Content.ArchivedDt) {
                                let recData = {
                                    biz_id: data.Content.Sysid,
                                    biz_surgery_info_id: data.Content.Vid,
                                    biz_type: 1, // 0麻醉单和苏醒单，1文书
                                    doc_name: data.Content.DocName,
                                    file_path: `${data.Content.Guid}.pdf`,
                                    create_by: this.currentUser.username,
                                    create_by_name: this.currentUser.dic_worker_name,
                                    create_time: data.Content.ArchivedDt
                                }
                                this.myaxios.post(`api/Operation/PaperlessDocRecord/Add`, recData)
                            }

                            this.loadAssociatedOperations(this.surgeryId).then(surgeries => {
                                this.loadDocumentLists(surgeries)
                            })
                        })
                    } else {
                        this.$alert(`<strong>您未拥有文书归档的权限！</strong>`, `操作失败`, {
                            dangerouslyUseHTMLString: true,
                            type: `warning`
                        })
                    }
                } else {
                    if (this.permissions && this.permissions.findIndex(item => item.permission === `Document:DisArchive`) != -1) {
                        // 取消归档
                        this.checkPaperlessDoc(c.docbizid).then(result => {
                            if (result) {
                                let req = axios.get(`${this.$root.DOCSERVICE_BASE}/Wth/DisArchiveInstance`, {
                                    headers: { 'content-type': `application/x-www-form-urlencoded` },
                                    params: { docbizid: c.docbizid, operator: this.currentUser.dic_worker_name }
                                })
                                req.then(data => {
                                    // 删除无纸化记录,文书3.2.6才会支持Content数据返回[jira:ICIS-13291]
                                    if (this.$root.PaperlessEnabled == 1 && data.Content && data.Content.Sysid > 0 && data.Content.ArchivedDt) {
                                        let recData = {
                                            biz_id: data.Content.Sysid,
                                            biz_type: 1 // 0麻醉单和苏醒单，1文书
                                        }
                                        this.myaxios.post(`api/Operation/PaperlessDocRecord/LogicDel`, recData)
                                    }
                                    this.loadAssociatedOperations(this.surgeryId).then(surgeries => {
                                        this.loadDocumentLists(surgeries)
                                    })
                                })
                            }
                        })
                    } else {
                        this.$alert(`<strong>您未拥有文书取消归档的权限！</strong>`, `操作失败`, {
                            dangerouslyUseHTMLString: true,
                            type: `warning`
                        })
                    }
                }
            } else if (!c.archiveddt) { // 单据
                // 归档
                if (this.permissions && this.permissions.findIndex(item => item.permission === `Desltop:Archive`) != -1) {
                    let req = this.myaxios.put(`/api/Operation/Home/Archive?surgeryInfoId=${c.surgeryId}&&recordType=${c.index}`)
                    req.then(data => {
                        this.loadAssociatedOperations(c.surgeryId).then(surgeries => {
                            this.loadDocumentLists(surgeries)
                        })
                    })
                } else {
                    this.$alert(`<strong>您未拥有单据归档的权限！</strong>`, `操作失败`, {
                        dangerouslyUseHTMLString: true,
                        type: `warning`
                    })
                }
            } else if (c.archiveddt) {
                // 取消归档
                if (this.permissions && this.permissions.findIndex(item => item.permission === `Desltop:DisArchive`) != -1) {
                    let req = this.myaxios.put(`/api/Operation/Home/UnArchive?surgeryInfoId=${c.surgeryId}&&recordType=${c.index}`)
                    req.then(data => {
                        this.loadAssociatedOperations(c.surgeryId).then(surgeries => {
                            this.loadDocumentLists(surgeries)
                        })
                    })
                } else {
                    this.$alert(`<strong>您未拥有单据取消归档归档的权限！</strong>`, `操作失败`, {
                        dangerouslyUseHTMLString: true,
                        type: `warning`
                    })
                }
            }
        },
        // 无纸化文档校验
        checkPaperlessDoc(bizid) {
            return new Promise((resolve, reject) => {
                let that = this
                if (that.paperlessDocVerification && that.paperlessDocVerification != ``) {
                    let postdata = {
                        biz_surgery_info_id: that.surgeryId,
                        biz_type: 1,
                        biz_id: bizid
                    }
                    let req = this.myaxios.post(`/api/Operation/Home/checkPaperlessDoc`, postdata)
                    req.then(data => {
                        if (data) {
                            if (!data.Status && data.Message) {
                                that.$message.error(data.Message)
                            }
                            resolve(data && data.Status)
                        } else {
                            resolve(true)
                        }
                    })
                        .catch(e => {
                            console.log(e)
                            resolve(false)
                        })
                } else {
                    resolve(true)
                }
            })
        },
        gotoDocument(document) {
            this.$confirm(`转到患者文书, 是否继续?`, `提示`, {
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`,
                closeOnClickModal: false
            }).then(() => {
                let r = _.find(this.business, { business_level: `M004` })
                // this.$router.push(`${(r && r.url) || `/`}?surgery_id=${this.surgeryId}&isOnlyShowMain=true&record_type=1&workbar=${r.workbar}&document_id=${document.docid}`)
                let url = (r && r.url) || `/`
                url += url.indexOf(`?`) > -1 ? `&` : `?`
                url = `${(r && r.url) || `/`}?surgery_id=${this.surgeryId}&isOnlyShowMain=true&record_type=1&workbar=${r.workbar}&document_id=${document.DocId}`
                let routeUrl = this.$router.resolve({
                    path: url
                })
                var w = this.screenWidth - 10
                var h = this.screenHeight - 10
                if (typeof winformMsg != `undefined`) {
                    w = w + 500
                    h = h + 400
                }
                window.open(routeUrl.href, ``, `width=${w},height=${h},top=10,left=10`)
            })
        },
        loadDocArchiveView({ row }) {
            this.thisrow = row
            this.is_sealed = row.is_sealed
            this.ward_id = row.dic_operating_ward_id ? `ow_${row.dic_operating_ward_id}` : `rw_${row.dic_recovery_ward_id}`
            this.drawerVisible = true
            this.surgeryId = row.id
            console.log(row.documentList)
            this.documentList = row.documentList
        },
        loadDicDocManagementList(r) {
            let that = this
            if (r && r.length > 0) {
                let vid = r[0].id
                return new Promise((resolve, reject) => {
                    let req = axios.get(`${this.$root.DOCSERVICE_BASE}/DocCenter/Setting/GetDicDocManagementList`, {
                        headers: { 'content-type': `application/x-www-form-urlencoded`, 'Authorization': sessionStorage.getItem(`doctoken`) },
                        params: { deptno: `acis2020`, permission: `0-11111111111`, vid: vid }
                    })
                    req.then(dicDocManagementList => {
                        that.DicDocManagementList = dicDocManagementList
                        resolve(that.DicDocManagementList)
                    }).then(d => {
                        that.loadDocumentConfig().then(d => {
                            console.log(111)
                            this.loadDocumentLists(r).then()
                        })
                    })
                })
            } else {
                that.alldata = r
            }
        },
        loadDocumentConfig() {
            let that = this
            return new Promise((resolve, reject) => {
                let req = this.myaxios.get(`/api/AcisSystem/DocumentConfig/Get`)
                req.then(DocumentConfig => {
                    that.DocumentConfig = DocumentConfig
                    resolve(DocumentConfig)
                })
            })
        },
        loadDocumentLists(surgerys) {
            let that = this
            let surgeryids = surgerys.map(d => {
                return d.id
            })
            return new Promise((resolve, reject) => {
                let req = this.myaxios.post(`/api/Operation/Home/ArchiveLists`, surgeryids)
                req.then(archiveListdata => {
                    // if (archiveListdata.length == 0) {
                    //     return
                    // }
                    surgerys.map(surgery => {
                        let r = []
                        let surgeryid = surgery.id
                        if (archiveListdata.length > 0) {
                            let archiveList = _.filter(archiveListdata, item => item.biz_surgery_info_id == surgery.id)
                            let mzdList = _.filter(archiveList, item => item.enum_record_type != 2)
                            let fsdList = _.filter(archiveList, item => item.enum_record_type == 2)

                            r = [
                                {
                                    surgeryId: surgeryid,
                                    surgery: surgery,
                                    index: `MZD`,
                                    hasChildren: true,
                                    children:
                                        _.map(mzdList, d => {
                                            return {
                                                surgeryId: surgeryid,
                                                index: d.enum_record_type,
                                                docno: -d.enum_record_type,
                                                label: d.file_name,
                                                archiveddt: d.is_archived ? d.archive_date : ``
                                            }
                                        }) || [],
                                    label: `麻醉单`
                                },
                                {
                                    surgeryId: surgeryid,
                                    surgery: surgery,
                                    index: `FSD`,
                                    hasChildren: true,
                                    children:
                                        _.map(fsdList, d => {
                                            return {
                                                surgeryId: surgeryid,
                                                index: d.enum_record_type,
                                                docno: -d.enum_record_type,
                                                label: d.file_name,
                                                archiveddt: d.is_archived ? d.archive_date : ``
                                            }
                                        }) || [],
                                    label: `复苏单`
                                }
                            ]
                        }

                        r = r.concat(
                            _.filter(_.orderBy(that.DicDocManagementList.data, `PrintOrder`), d => {
                                let dc = _.find(that.DocumentConfig, d3 => d3.document_id == d.DocNo && d3.is_show_medical == true)
                                return (
                                    dc &&
                                        _.some(dc.regions, reg => {
                                            return reg.dic_operating_ward_id == surgery.dic_operating_ward_id || reg.dic_recovery_ward_id == surgery.dic_recovery_ward_id
                                        })
                                )
                            }).map(dr => {
                                let d = { ...dr }
                                let ddddd = _.find(that.DocumentConfig, d3 => d3.document_id == d.DocNo)
                                d.issingleton = ddddd && ddddd.is_singleton
                                d.is_show_medical = ddddd && ddddd.is_show_medical
                                d.surgeryId = surgeryid
                                d.surgery = surgery
                                d.index = `${d.DocNo}`
                                d.hasChildren = d.IsSurportHtml
                                d.children = []
                                d.label = d.DocName
                                return d
                            })
                        )
                        surgery.documentList = r
                        // 设置列配置
                        // let thisstyle = `font-size:25px;`
                        _.forEach(r, d => {
                            that.$set(surgery, d.label, `×`)
                            that.$set(surgery, d.label + `style`, `font-size:25px;color:red;`)

                            if (this.columnList.findIndex(s => s.prop == d.label) == -1) {
                                var column = {
                                    type: `string`,
                                    area: [1, 2],
                                    label: d.label,
                                    prop: d.label,
                                    cellstyle: surgery[d.label + `style`],
                                    colspan: null,
                                    isListable: true,
                                    options: null,
                                    width: `100`
                                }
                                this.columnList.push(column)
                                let lcs = _.orderBy(this.columnList, function(lc) {
                                    return _.findIndex(that.user_config_columns2, { col_name: lc.prop })
                                })
                                this.configColumns = lcs.map(c => {
                                    return { value: c.prop, label: c.label, isListable: c.isListable }
                                }).filter(d => {
                                    return d.label != `unique` && d.isListable
                                })
                                // this.user_config_columns = (data && _.filter(data, { enabled: true }).map(d => d.col_name)) || []
                            }
                        })
                    })
                    resolve(surgerys)
                })
            }).then(surgerys => {
                this.loadInstances(surgerys).then(d => {
                    _.map(surgerys, surgery => {
                        let archiveQuantity = 0
                        let documentAllCount = 0
                        _.map(surgery.documentList, document => {
                            archiveQuantity += document.children && _.filter(document.children, item => item.archiveddt && item.archiveddt.trim() != ``).length || 0
                            documentAllCount += document.children && document.children.length || 0
                        })
                        surgery.archive_quantity = archiveQuantity
                        surgery.documentAllCount = documentAllCount
                    })
                    this.alldata = surgerys
                })
            })
        },
        loadInstances(surgerys) {
            let that = this
            return new Promise((resolve, reject) => {
                console.log(`afterloadDocumentLists`)
                console.log(surgerys)
                if (surgerys.length > 0) {
                    let items = []
                    _.map(surgerys, surgery => {
                        let surgerydocumentList = surgery.documentList.filter(d => d.hasChildren && d.DocNo > 0)
                        _.map(surgerydocumentList, d => {
                            items.push({
                                docid: d.index, issingleton: d.issingleton, vid: d.surgeryId
                            })
                        })
                    })
                    let objs = {
                        dept: `acis2020`,
                        items: items
                    }
                    // 调用文书获取结果
                    let url = `${this.$root.DOCSERVICE_BASE}/Wth/QueryWTHMainData`
                    axios.post(url, Qs.stringify(objs), Object.assign({
                        emulateJSON: true
                    })).then(res => {
                        if (res.Status == `SUCCESS`) {
                            let contents = res.Content
                            contents = _.filter(contents, f => {
                                return f.istemplate == `0`
                            }).map(f => {
                                f.index = `${f.docbizid}`
                                f.docno = f.docno
                                f.label = f.docname
                                return f
                            })
                            _.map(surgerys, surgery => {
                                let surgerydoc = _.filter(contents, item => item.vid == surgery.id)

                                _.map(surgery.documentList, document => {
                                    let lavalue = `×`
                                    if (document.index == `MZD` || document.index == `FSD`) {
                                        if (document.hasChildren && document.children.length != 0) {
                                            let wgdsl = document.children.findIndex(f => f.archiveddt == null || f.archiveddt == ``)
                                            if (wgdsl == -1) {
                                                lavalue = `√`
                                                surgery[document.label + `style`] = lavalue == `×` ? `font-size:25px;color:red;` : `font-size:25px;color:green;`
                                            }
                                        }
                                        surgery[document.label] = lavalue
                                    } else {
                                        let r = _.filter(surgerydoc, s => s.docno == document.DocNo)
                                        // if (surgery.id == 4544 && document.label == `麻醉小结_按照样式给边框`) {
                                        //     console.log(4544 + `麻醉小结_按照样式给边框`)
                                        //     console.log(r)
                                        // }

                                        if (r) {
                                            this.$set(document, `children`, r)
                                            if (document.hasChildren && document.children.length != 0) {
                                                let wgdsl = document.children.findIndex(f => f.archiveddt == null || f.archiveddt == ``)
                                                if (wgdsl == -1) {
                                                    lavalue = `√`
                                                    surgery[document.label + `style`] = lavalue == `×` ? `font-size:25px;color:red;` : `font-size:25px;color:green;`
                                                }
                                            }
                                        }

                                        surgery[document.label] = lavalue
                                    }
                                    if (surgerys.length == 1) {
                                        let r = that.alldata && that.alldata.find(s => s.id == surgerys[0].id)
                                        if (r) {
                                            r.documentList = surgery.documentList
                                            r[document.label] = surgery[document.label]
                                        }
                                    }
                                })
                                this.documentList = surgery.documentList
                            })
                        }
                        resolve(surgerys)
                    }).catch(e => {
                        console.log(e)
                    })
                }
            })
        },
        loadAssociatedOperations(surgeryInfoId) {
            return this.myaxios.post(`api/Intraoperative/Anaesthesia/AssociatedOperations?surgeryInfoId=${surgeryInfoId}`)
        },
        // loadDocumentView({ row }) {
        //     this.drawerVisible2 = true
        //     this.ward_id = row.dic_operating_ward_id ? `ow_${row.dic_operating_ward_id}` : `rw_${row.dic_recovery_ward_id}`
        //     this.surgeryId = row.id
        //     this.loadAssociatedOperations(row.id).then(surgeries => {
        //         this.loadDocumentList(surgeries)
        //     })
        // },
        loadInstance(doc) {
            if (doc.docno > 0) {
                this.document = {
                    title: doc.label,
                    docno: doc.docno,
                    docbizid: doc.docbizid,
                    dialogFormVisible: true
                }
                this.src = undefined
                // this.document.dialogFormVisible=true
                this.$nextTick(() => {
                    this.$refs.doc.loadDocument()
                })
            } else {
                this.loading = true
                let req = this.myaxios.get(`/api/Operation/Home/ArchivePdf?surgeryInfoId=${this.surgeryId}&recordType=${doc.index}`)
                req.then(data => {
                    this.document = {
                        title: doc.label,
                        docno: doc.docno,
                        docbizid: doc.docbizid,
                        dialogFormVisible: true
                    }
                    // this.document.dialogFormVisible=true
                    this.src = pdf.createLoadingTask(`data:application/pdf;base64,${data}`)
                    this.src.then(content => {
                        this.numPages = content.numPages
                        this.loading = false
                    })
                }).catch(e => {
                    this.loading = false
                })
            }
        },
        // loadChecked({ row }) {
        //     this.checkedRow = row
        // },
        selectionChange({ row }) {
            this.checkedRow = row
        },
        seal() {
            let rows = _.filter(this.checkedRow, d => {
                return !d.is_sealed
            })
            if (rows.length !== this.checkedRow.length) {
                this.$message.error(`部分患者病案未取消封存，无法封存`)
                return false
            }
            rows = _.filter(this.checkedRow, d => {
                return !d.is_sealed && d.enum_surgery_status >= 40
            })
            if (rows.length !== this.checkedRow.length) {
                this.$message.error(`部分患者手术未结束，无法封存`)
                return false
            }
            rows = _.filter(this.checkedRow, d => {
                return d.sealing_status != 1
            })
            if (rows.length !== this.checkedRow.length) {
                this.$message.error(`部分患者审核中，无法封存`)
                return false
            }
            var that = this
            // let sucount = 0
            if (rows.length > 0) {
                rows.map(function(d, index, array) {
                    let reqs = that.myaxios.put(`/api/Operation/Home/Seals?surgeryInfoId=${d.id}&checkTip=true&checkRecordArchivePermission=false`)
                    reqs.then((data) => {
                        if (data && data.status == 0) {
                            that.$confirm(`“${d.patient_name}”“${d.visit_no}”${data.msg}`, `提示`, {
                                confirmButtonText: `确定`,
                                cancelButtonText: `取消`,
                                type: `warning`,
                                closeOnClickModal: false
                            }).then(data => {
                                that.myaxios.put(`/api/Operation/Home/Seals?surgeryInfoId=${d.id}&checkTip=false&checkRecordArchivePermission=false`).then(data => {
                                    that.$message.success(`“${d.patient_name}”“${d.visit_no}”${data.msg}`)
                                    if (index == rows.length - 1) {
                                        that.ReloadListData()
                                    }
                                })
                            }).catch((e) => {
                                that.ReloadListData()
                            })
                        } else {
                            that.$message.success(`“${d.patient_name}”“${d.visit_no}”${data.msg}`)
                            if (index == rows.length - 1) {
                                that.ReloadListData()
                            }
                        }
                    })
                })
            } else {
                this.$message.warning(`未选中未封存病例`)
            }
        },
        unSeal() {
            var that = this
            let rows = _.filter(this.checkedRow, d => {
                return d.is_sealed
            })
            if (rows.length !== this.checkedRow.length) {
                this.$message.warning(`部分患者病案未封存，无法取消封存`)
                return false
            }
            rows = _.filter(this.checkedRow, d => {
                return d.sealing_status != 1
            })
            if (rows.length !== this.checkedRow.length) {
                this.$message.error(`部分患者审核中，无法取消封存`)
                return false
            }
            if (rows.length > 0) {
                let reqs = this.myaxios.put(
                    `/api/Operation/Home/UnSeals`,
                    rows.map(d => d.id)
                )
                reqs.then((data) => {
                    if (data && data.status == 1) {
                        that.ReloadListData()
                        this.$message.success(`${data.msg}`)
                    }
                })
            } else {
                this.$message.warning(`未选中封存病例`)
            }
        },
        printDocment(c) {
            let that = this
            let req2 = this.myaxios.get(`/api/AcisSystem/Config/GetByKey?key=isShowSendPrintMessage`)
            req2.then(isShow => {
                if (c.docno > 0 || c.DocNo > 0) {
                    this.$store.dispatch(`PRINT_PDF`, {
                        host: this.$root.DOCSERVICE_BASE,
                        params: Object.assign(
                            {
                                docid: c.docid || c.docno,
                                id1: this.surgeryId,
                                docbizid: c.docbizid,
                                from: this.$moment().format(`YYYYMMDDHHmm`),
                                to: this.$moment().format(`YYYYMMDDHHmm`)
                            },
                            { isShowSendPrintMessage: isShow.value }
                        )
                    })
                } else {
                    let req = this.myaxios.get(`/api/Operation/Home/ArchivePdf?surgeryInfoId=${this.surgeryId}&recordType=${c.index}`)
                    req.then(data => {
                        req.then(data => {
                            printJs({ printable: data,
                                type: `pdf`,
                                base64: true,
                                onPrintDialogClose: () => {
                                    if (isShow.value === `true`) {
                                        setTimeout(function() {
                                            that.$confirm(`提示`, {
                                                title: `提示`,
                                                message: `请确认打印是否已完成`,
                                                confirmButtonText: `打印完成`,
                                                cancelButtonText: `打印未完成`,
                                                type: `warning`
                                            }).then(() => {

                                            }).catch(e => {
                                            })

                                            // ElementUI.MessageBox.confirm(`请确认打印是否已完成`, `提示`, {
                                            //     confirmButtonText: `打印完成`,
                                            //     cancelButtonText: `打印未完成`
                                            // })
                                        }, 2000)
                                    }
                                } })
                        }).catch(e => console.log(e))
                    }).catch(e => {
                        console.log(e)
                        this.loading = false
                    })
                }
            }).catch(e => {
                console.log(e)
            })
        },
        loadConfigColumns() {
            let req = this.myaxios.get(`api/AcisSystem/SystemServer/GetColumnConfig?tableName=api_Preoperative/Apply_medicalrecord`)
            req.then(data => {
                let lcs = _.orderBy(this.columnList, function(lc) {
                    return _.findIndex(data, { col_name: lc.prop })
                })
                this.configColumns = lcs.map(c => {
                    return { value: c.prop, label: c.label, isListable: c.isListable }
                }).filter(d => {
                    return d.label != `unique` && d.isListable
                })
                this.user_config_columns2 = data && _.filter(data, { enabled: true })
                this.user_config_columns = (data && _.filter(data, { enabled: true }).map(d => d.col_name)) || []
            })
        },
        SaveUserColumns() {
            let uc = this.configColumns.map((c, index) => {
                return {
                    col_name: c.value,
                    display_order: index,
                    enabled: _.includes(this.user_config_columns, c.value),
                    table_name: `api_Preoperative/Apply_medicalrecord`
                }
            })
            let req = this.myaxios.post(`/api/AcisSystem/SystemServer/SetColumnConfig`, uc)
            req.then(data => {
                this.$message.success(`保存成功`)
                if (this.reload) {
                    this.reload()
                }
            }).catch(e => {})
        },
        configColumnDrop() {
            // if (!this.columnConfig) return
            const tbody = document.querySelector(`.config-column .el-checkbox-group`)
            const _this = this
            Sortable.create(tbody, {
                group: { name: `config-columns`, push: false, put: false },
                animation: 180,
                fallbackOnBody: true,
                delay: 0,
                onUpdate({ newIndex, oldIndex }) {
                    // 交换排序
                    if (newIndex == oldIndex) return
                    // console.log({ newIndex, oldIndex })
                    const currRow = _this.configColumns.splice(oldIndex, 1)[0]
                    _this.configColumns.splice(newIndex, 0, currRow)
                }
            })
        }
    },
    watch: {
        is_own: function() {
            this.ReloadListData()
        }
    }
}
</script>
<style  lang="less">
.document-medicalrecord .el-dialog__body {
    padding: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Medicalrecord/Index.vue